var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BC1535;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,20c0,11.05-8.95,20-20,20h0C8.95,40,0,31.05,0,20v0C0,8.95,8.95,0,20,0h0C31.05,0,40,8.95,40,20L40,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.43,9.51H14.57c-2.8,0-5.06,2.27-5.06,5.06v10.85c0,2.8,2.27,5.06,5.06,5.06h10.85 c2.8,0,5.06-2.27,5.06-5.06V14.57C30.49,11.78,28.22,9.51,25.43,9.51z M28.68,25.06c0,2-1.62,3.62-3.62,3.62H14.94 c-2,0-3.62-1.62-3.62-3.62V14.94c0-2,1.62-3.62,3.62-3.62h10.13c2,0,3.62,1.62,3.62,3.62V25.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.01,14.57c-3,0-5.43,2.43-5.43,5.43c0,3,2.43,5.43,5.43,5.43S25.44,23,25.44,20 C25.44,17,23.01,14.57,20.01,14.57z M20.01,23.62c-1.99,0-3.62-1.62-3.62-3.62s1.62-3.62,3.62-3.62s3.62,1.62,3.62,3.62 S22,23.62,20.01,23.62z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25.8,
    cy: 14.21,
    r: 1.09
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.11fd5b79fc9382539e080c0936b9b44e.svg";
export { ForwardRef as ReactComponent };